var accordionMobileFaqs = {
    accordion: function () {

        //$('.c-faqs-page-accordion > .c-faqs-page-accordion__item:eq(0) .c-faqs-page-accordion__title').addClass('active').next().slideDown();

        $('.c-faqs-page-accordion__button').click(function (j) {
            var dropDown = $(this).closest('.c-faqs-page-accordion__item').find('.c-faqs-page-accordion__content');

            //$(this).closest('.c-faqs-page-accordion').find('.c-faqs-page-accordion__content').not(dropDown).slideUp();

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).attr('aria-expanded' , 'true') 
            } else {
                //$(this).closest('.c-faqs-page-accordion').find('.c-faqs-page-accordion__title.active').removeClass('active');
                $(this).addClass('active');
                $(this).attr('aria-expanded' , 'false') ;
            } 

            dropDown.stop(false, true).slideToggle();

            //j.preventDefault();
        });

    }
}

$(function () {

    if ($('.js-faqs-accordeon').length) {
        accordionMobileFaqs.accordion();
    }
})